import {
  checkUserHasAdminRole,
  checkUserHasManagerRole,
  checkUserHasMemberRole,
  getLandingRoute,
} from "app/services/app.state.service";
import { Navigate } from "react-router-dom";
import { SkillMatrixAdminView } from "app/components/skills/SkillMatrixAdminView";
import { SkillMatrixManagerView } from "app/components/skills/SkillMatrixManagerView";
import { SkillMatrixMemberView } from "app/components/skills/SkillMatrixMemberView";

export const SkillMatrixRouterFactory = () => {
  if (checkUserHasAdminRole()) {
    return <SkillMatrixAdminView />;
  } else if (checkUserHasManagerRole()) {
    return <SkillMatrixManagerView />;
  } else if (checkUserHasMemberRole()) {
    return <SkillMatrixMemberView />;
  } else {
    // Not allowed here — route to the user's landing screen rather than
    // reloading the app, which would blank the screen on slower networks.
    return <Navigate to={getLandingRoute()} replace />;
  }
};

